import validate from './validate';

const validators = {
  isNotEmpty: value => value.length !== 0,
  startsWith07: value => /^(\+44|44|0)7/.test(value),
  notStartsWith070: value => !/^070/.test(value),
  notStartsWith4470: value => !/^4470/.test(value),
  notStartsWithPlus4470: value => !/^\+4470/.test(value),
  isNumeric: value => /^\+?\d+$/i.test(value),
  hasCorrectLength: value => /^(44|\+44|0)\d{10}$/.test(value)
};

const validatorsLive = {
  startsWith07: value => /^([+40]$|[+4]4$|(\+44|44|0)(7|$))/.test(value),
  notStartsWith070: validators.notStartsWith070,
  notStartsWith4470: validators.notStartsWith4470,
  notStartsWithPlus4470: validators.notStartsWithPlus4470,
  isNumeric: value => /^\+?\d*$/i.test(value),
  hasCorrectLength: value => /^(.{0,3}|(44|\+44|0)\d{0,10})$/.test(value)
};

const validationErrors = {
  isNotEmpty: 'You must enter a valid UK mobile number',
  startsWith07: 'You must enter a valid UK mobile number',
  notStartsWith070: 'You must enter a valid UK mobile number',
  notStartsWith4470: 'You must enter a valid UK mobile number',
  notStartsWithPlus4470: 'You must enter a valid UK mobile number',
  isNumeric: 'You must enter a valid UK mobile number',
  hasCorrectLength: 'You must enter a valid UK mobile number'
};

export const checkMobileNumberLive = (
  number => validate(number, validatorsLive, validationErrors)
);

export const checkMobileNumber = (
  number => validate(number, validators, validationErrors)
);

export default checkMobileNumber;
